import {Component, OnInit} from '@angular/core';
import {SidebarComponent} from '../../components/sidebar/sidebar.component';
import {Router, RouterLink, RouterOutlet} from '@angular/router';
import {ModalComponent} from '../../../core/components/modal/modal.component';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {CreatorDashboardService} from '../../services/creator/creator-dashboard.service';
import {DashboardOnboarding} from '../../entities/dashboard/onboarding.entity';
import {LocalStorageService} from '../../../core/services/localstorage/local-storage.service';

@Component({
  selector: 'app-creator-layout',
  imports: [
    SidebarComponent,
    RouterOutlet,
    ModalComponent,
    TranslocoPipe,
  ],
  templateUrl: './creator-layout.component.html',
  styleUrl: './creator-layout.component.scss'
})
export class CreatorLayoutComponent implements OnInit{
  public announcementModalId: string|null = 'photographer-availabilities';
  public showAnnouncementModal = false;
  public onboarding: DashboardOnboarding|null = null;

  public constructor(
    private readonly transloco: TranslocoService,
    private readonly router: Router,
    private readonly dashboardService: CreatorDashboardService,
    private readonly localStorage: LocalStorageService,
  ) {
  }

  public ngOnInit() {
    this.canShowAnnouncementModal();
    this.dashboardService.getOnboarding().subscribe(
      (onboarding: DashboardOnboarding) => {
        this.onboarding = onboarding;
      }
    );
  }

  public canShowAnnouncementModal(): void {
    if (!this.announcementModalId) {
      this.showAnnouncementModal = false;
      return;
    }
    const key = `announcement-modal__${this.announcementModalId}`;
    const alreadyShown = this.localStorage.get(key);
    if (alreadyShown) {
      this.showAnnouncementModal = false;
    } else {
      this.showAnnouncementModal = true;
      this.localStorage.save(key, new Date().getTime().toString());
    }
  }

  public redirectToFeature(): void {
    this.closeAnnouncementModal();
    this.router.navigate(['/manage/calendar']);
  }

  public getImageSrc(): string {
    // Get current locale, fallback to 'en'
    const locale = this.transloco.getActiveLang() || 'en';
    const supportedLocales = ['fr', 'en'];
    const finalLocale = supportedLocales.includes(locale) ? locale : 'en';
    return `/assets/images/announcement-modals/availabilities/${finalLocale}.png`;
  }
  public closeAnnouncementModal(): void {
    this.showAnnouncementModal = false;
  }
}
